import React from 'react';
import { getProductDescription, getProductLink } from '../../util';
import { PropTypes } from 'prop-types';
import { identityState,productState,combineStates } from '../../store';
import { connect } from 'react-redux';
import { isArray, isBoolean } from 'lodash';
const ProductDescriptionComponent = (props)  => { 
  const{ product,NSTbom_ACC,shortdescriptioncn}=props;
  const link = product.productLink || getProductLink( product.name );
  const {user} = props;
  const {culture} = user;
  var Culture_lang='';
  var NST_description='';
  var NST_ACC_View=false;
  if(product._accessory?.assignedValue?.name!=undefined){
    NST_ACC_View=NSTbom_ACC?.length>0 && NSTbom_ACC.any(b=>(b.identifier==product._accessory.fullyQualifiedName || b.name===product._accessory.assignedValue.name ||b.identifier.split('.')[1]==product._accessory.name) && b.configuredAcc && b.value== product._accessory.assignedValue.name)
  }
  if(product.fgProduct && product.fgProduct.length>0){
    NST_description=product.fgProduct[0].Description
  }
  if(shortdescriptioncn) 
  {
    if(product.superCodeLSO && product.superCodeLSO.length>0 ){
    let shortDescriptionCN=props.products && props.products[product.superCodeLSO] && props.products[product.superCodeLSO].shortDescriptionCN;
    return <div className='Product-Description'>
    <span >{ shortDescriptionCN}</span>
   </div>}
    else{
    let shortDescriptionCN=product.shortDescriptionCN;
    return <div className='Product-Description'>
    <span >{ shortDescriptionCN}</span>
   </div>}
  }
  else{
  Object.keys(props.products).filter(p=>{if(props.products[p] && product.superCodeLSO && (props.products[p].code==product.superCodeLSO || props.products[p].name==product.superCodeLSO)){NST_description= props.products[p].description}})}
  const configuredproduct=product.configurableProduct || product.configuredAcc || (product._accessory?.assignedValue?.name!=undefined && product._accessory?.assignedValue?.name ==product?._accessory?.bom?.value)
  const looseAcc=product._accessory?.properties?.LooseAcc || product.LooseAcc;
   if(culture.indexOf('-')>0){
        Culture_lang = culture.split( '-' )[0].toUpperCase();
      }
   if(product.materialName=='MB_VD4_D' ||product.code?.startsWith('V')|| (product._accessory?.name!=undefined && product._accessory?.name.indexOf("ACC_VD4")>-1)){
    return <div className='Product-Description'>
    <span title = { getProductDescription(product,Culture_lang) } >{ getProductDescription(product,Culture_lang) }</span>
   </div>}
    if(NST_description?.length>0){
    return <a href={ link } target="_blank">
    <div className='Product-Description'>
      <span style={{color:"green"}} title = {NST_description } >{NST_description }</span>
    </div>
  </a>
  } 

  let actualDescription = getProductDescription(product,Culture_lang);
  let modifiedDescriptionTokens = actualDescription?.split(",").map(c=>c.trim()); // separate as per comma and remove spaces from both sides of the token
  let modifiedDescription = modifiedDescriptionTokens?.join(", ")

  return <a href={ link } className='Product-Description' target="_blank">
    <div>
    {((isArray(configuredproduct) ? configuredproduct[0] :configuredproduct) && product.superCodeLSO!="待开") || NST_ACC_View?<span style={{color:"green"}} title = { modifiedDescription } >{ modifiedDescription }</span>:
    !(isArray(configuredproduct) ? configuredproduct[0] :configuredproduct) && !looseAcc || product.bom?.length>0?<span style={{color:"blue"}} title = { modifiedDescription } >{ modifiedDescription }</span>:
    <span title = { modifiedDescription } >{ modifiedDescription }</span>}
    </div>
  </a>
};
 
ProductDescriptionComponent.propTypes = {
  product: PropTypes.shape( {} )
};
 
export const ProductDescription = connect(combineStates(identityState,productState))(ProductDescriptionComponent);